import React, { useState } from "react";
import InputWrapper from "../InputWrapper";
import classes from "./SliderInput.module.css";

const SliderInput = ({
  title,
  question,
  help_text,
  objectName = "projectionSettings",
  fieldName,
  inputs,
  updateInput,
  min = 0,
  max = 3,
  step = 0.1,
}) => {
  const [currentValue, setCurrentValue] = useState(
    inputs[objectName][fieldName] * 100
  );

  const sliderHandler = (event) => {
    const newValue = parseFloat(event.target.value);
    setCurrentValue(newValue);
  };

  const handleChangeComplete = () => {
    updateInput(objectName, fieldName, currentValue / 100);
  };

  return (
    <InputWrapper title={title} desc_text={question} help_text={help_text}>
      <section className={classes.slider_container}>
        <input
          id="salarySlider"
          type="range"
          min={min}
          max={max}
          step={step}
          value={currentValue}
          onChange={sliderHandler}
          onMouseUp={handleChangeComplete}
          onKeyUp={handleChangeComplete}
          className={classes.slider}
        />
        <p>{currentValue}%</p>
      </section>
    </InputWrapper>
  );
};
export default SliderInput;
